module.exports = __webpack_public_path__ + "img/money.5f70bd81.png";